import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import { useQuery } from '../../hooks/useQuery'

import MainLayout from '../../components/Core/MainLayout'
import AppNavbar from '../../components/Core/AppNavbar'
import Documents from '../../components/Documents/Documents'
import Document from '../../components/Documents/Document'
import DocumentForm from '../../components/Documents/DocumentForm'
import EmployeesDocuments from '../../components/Documents/EmployeesDocuments'
import EmployeeDocuments from '../../components/Documents/EmployeeDocument'
import DocumentPreview from '../../components/Documents/DocumentPreview'
import AcknowledgmentDocuments from '../../components/Documents/AcknowledgementDocuments'
import AcknowledgmentEmployees from '../../components/Documents/AcknowledgementEmployees'
import EmployeeOwnedDocument from '../../components/Documents/EmployeeOwnedDocument'
import EmployeesOwnedDocuments from '../../components/Documents/EmployeesOwnedDocuments'

const DocumentsScreen = () => {
  const { t } = useTranslation()
  const { tab: activeTab, document_id: documentId, employee_id: employeeId } = useQuery(['tab:documents', 'document_id', 'employee_id'])
  const history = useHistory()
  const { id: companyId } = useParams()

  const options = [{
    title: t('Documents'),
    key: 'documents',
  }, {
    title: t('Employees'),
    key: 'employees',
  }, {
    title: t('Required reading'),
    key: 'required_reading',
  }, {
    title: t('Required documents'),
    key: 'required_documents'
  }]

  const handleSelectTab = key => {
    history.push({search: `?tab=${key}`})
  }

  return (
    <MainLayout layoutClassName={styles.layout} screenClassName={styles.screen}>
      <div className={styles.navBar}>
        <AppNavbar
          options={options}
          selected={activeTab}
          onSelect={handleSelectTab} />
      </div>
      <div className={styles.content}>
        {
          (tab => {
            switch (tab) {
              case 'documents':
                return documentId ? <Document companyId={companyId} documentId={documentId} /> : <Documents />
              case 'employees':
                return employeeId ? <EmployeeDocuments employeeId={employeeId} /> : <EmployeesDocuments />
              case 'required_reading':
                return documentId ? <AcknowledgmentEmployees documentId={documentId} /> : <AcknowledgmentDocuments />
              case 'required_documents':
                return documentId ? <EmployeeOwnedDocument documentId={documentId} /> : <EmployeesOwnedDocuments />
              default:
                return null
            }
          })(activeTab)
        }
      </div>
      <DocumentForm companyId={companyId} />
      <DocumentPreview companyId={companyId} />
    </MainLayout>
  )
}

export default DocumentsScreen
